<template>
  <!--  查看违规内容  -->
  <van-dialog v-model="showViolation" title="违规记录" class="title" @confirm="onOk">
    <div show-icon class="warning">
      <van-icon name="warning" color="orange" style="margin: 5px" />
      <div>
        违规内容仅供参考，请自行辨别核实！<br/>
        违规内容不能外传，否则将取消所在店铺的标记功能以及不能查看标记。
      </div>
      </div>
    <div style="margin: 0 auto">
      <div class="flex align-center padding-xs" style="font-size: 15px;color: black;">
        <div class="title-index">序号</div>
        <div class="title-remark">违规内容</div>
        <div class="title-photoUrls">违规截图</div>
      </div>
      <div class="padding-xs">
        <template v-for="(item, index) in userViolationSignList">
          <div class="flex align-center padding-xs">
            <div class="index">{{index + 1}}</div>
            <div class="remark">{{item.remark}}</div>
            <div class="photoUrls">
              <div v-if="item.photoUrls">
                <div class="img-css" @click="violationImg(item.id)">查看截图</div>
              </div>
              <span v-else>暂无图片</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import Vue from 'vue';
import {Dialog, ImagePreview, Toast} from 'vant';
import {findUserViolation} from '@/api/user'
Vue.use(Dialog)
/* 主要是用来显示二维码，如果想带logo就往headImg里面传值 */
export default {
  name: 'violationSelect',
  components: {
  },
  props: {
    headImg: {
      type: String
    },
    userViolationSignList: {
      type: Object,
      required: true,
      default: null
    },
    showViolation: {
      type: Boolean,
      default: false
    },
  },
  model: {
  },
  data(){
    return{
      models:[],
      photoUrls:[],
    }
  },
  mounted () {

  },

  methods:{
    onOk(){
      this.$emit("changeShowViolation", false)
    },
    violationImg(id){
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      for (let i=0; i<this.models.length; i++){
        if (this.models[i].id == id) {
          Toast.clear()
          this.photoUrls = this.models[i].photoUrls
          return ImagePreview({
            images: this.photoUrls,
          })
        }
      }
      findUserViolation(id).then(res=>{
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.photoUrls = data.photoUrls;
          var info= {};
          info.id=id
          info.photoUrls=this.photoUrls
          this.models.push(info)
          ImagePreview({
            images: this.photoUrls,
          })
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>
.title{
  /deep/.van-dialog__header{
    padding-top:15px;
    font-size: 16px;
  }
}
.title-index{
  width: 20%;
  text-align: center;
}
.title-remark{
  width: 40%;
  text-align: center;
}
.title-photoUrls{
  width: 40%;
  text-align: center;
}
.index{
  width: 20%;
  text-align: center;
}
.remark{
  width: 40%;
  text-align: center;
  word-wrap: break-word;
  font-size: 12px;
}
.photoUrls{
  width: 40%;
  text-align: center;
  font-size: 12px;
  .img-css{
    cursor: pointer;
    color:#2D8cF0;
  }
}
.warning{
  border: 1px solid #ffd77a;
  background-color: #fff9e6;
  padding: 5px;
  border-radius: 5px;
  color: red;font-size: 12px;
  width: 90%;
  margin-left: 3%;
  margin-bottom: 3px;
  margin-top: 3px;
  display:flex;
  justify-content: space-between;
}

</style>

